import table from '../assets/data/digitoegankelijkheid/digitoegankelijk_tabel.htm'

function OnMobileDevice() {

  return (
    <div style={{ 'top':'200px', 'position':'absolute' }}>

      <p>
        De interactieve droogtevisualisatie kan niet worden getoond op uw apparaat.
        Bekijk de
        <a href={table} target="_blank">
          {` toegankelijke datatabel`}
        </a>
        .
      </p>

     </div>
  );
}

export default OnMobileDevice;
